
import { Component, Prop, Vue } from 'nuxt-property-decorator';
import type { PropType } from 'vue';
import { StatisticBook } from '../CeSystimeauthorinfoIbookusageperweek.vue';
import Accordion from '@/components/ui/accordion/Accordion.vue';

@Component({
  components: { Accordion }
})
export default class AuthorInfoIbookUsagePerWeekItem extends Vue {
  @Prop({
    type: Object as PropType<StatisticBook>,
    default: () => {}
  })
  item!: StatisticBook;

  @Prop({ type: String as PropType<any[]> })
  type!: any[];

  accordionExpanded: boolean = false;

  renderContent() {
    this.accordionExpanded = !this.accordionExpanded;
  }
}
